type FinAISettings = NonNullable<Window['intercomFinAISettings']>
type MessengerSettings = NonNullable<Parameters<NonNullable<Window['Intercom']>>[1]>

export const REFRESH_LEAD_MS = 5 * 60 * 1000

export const getJwtExpiresAt = (jwt: string | undefined): number | null => {
  const payload = jwt?.split('.')[1]
  if (!payload) {
    return null
  }

  try {
    const { exp } = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/'))) as {
      exp?: unknown
    }
    return typeof exp === 'number' ? exp : null
  } catch {
    return null
  }
}

export const getRefreshDelayMs = (expiresAt: number, now = Date.now()) =>
  Math.max(expiresAt * 1000 - REFRESH_LEAD_MS - now, 0)

// `expires_at` is our own field for scheduling; Intercom does not need it.
export const toIntercomSettings = ({
  expires_at: _expiresAt,
  ...intercomSettings
}: FinAISettings): MessengerSettings => intercomSettings
